<!--
File: cc-cell.component.html
Project: catalog-cloud
File Created: Thursday, 17th February 2022 11:48:25
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Thursday, 28th November 2024 5:37:40 pm
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->
<div
  class="innerCellTemplate cell-template z-0"
  [ngClass]="[locked ? 'cell-locked' : 'cell-unlocked']"
>
  <div class="cell-buttons" *ngIf="!locked">
    <app-cc-cell-template-button
      [grid]="grid"
      [cellId]="grid.cells.indexOf(cell)"
      [side]="'right'"
      class="side side-h side-right"
      (sizeChanged)="getCellSize()"
    ></app-cc-cell-template-button>
    <app-cc-cell-template-button
      [grid]="grid"
      [cellId]="grid.cells.indexOf(cell)"
      [side]="'left'"
      class="side side-h side-left"
      (sizeChanged)="getCellSize()"
    ></app-cc-cell-template-button>
    <app-cc-cell-template-button
      [grid]="grid"
      [cellId]="grid.cells.indexOf(cell)"
      [side]="'top'"
      class="side side-v side-top"
      (sizeChanged)="getCellSize()"
    ></app-cc-cell-template-button>
    <app-cc-cell-template-button
      [grid]="grid"
      [cellId]="grid.cells.indexOf(cell)"
      [side]="'bottom'"
      class="side side-v side-bottom"
      (sizeChanged)="getCellSize()"
    ></app-cc-cell-template-button>
  </div>
</div>
